module.exports = __webpack_public_path__ + "static/media/tone3_ok.50637f1a.svg";